import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { User } from 'src/app/interfaces/core/user.entity';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { getUserAvatar } from 'src/app/utils/avatar';

@Component({
	selector: 'app-comments-modal',
	templateUrl: './comments-modal.component.html',
	styleUrls: ['./comments-modal.component.scss'],
})
export class CommentsModalComponent implements OnInit {
	dialogSubscription = new Subscription();
	commentText: string = '';
	aspectIdToShow: string = '';
	actualUser: string = '';
	comments2: any[] = [];
	empty: boolean = true;
	commentsDb: any[] = [];
	commentsLocal: any[] = [];
	hasCommentsDb: boolean = false;
	hasCommentsLocal: boolean = false;
	isEditMode: boolean = false;
	roleComment: string = '';
	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: any,
		public dialog: MatDialog,
		private ls: LocalStorageService,
	) {
		this.actualUser = this.ls.getItem('name');
		this.roleComment = this.ls.getItem('role');
	}

	ngOnInit() {
		if (this.roleComment === 'institution') {
			this.isEditMode = this.data.isEdit;
		}
		console.log(this.isEditMode);
		const haveComments =
			this.data.comment?.[this.data.aspect]?.comments ||
			this.data.comment?.[this.data.aspect]?.[this.data.index]?.comments;

		const haveLocalComments = this.getFromLocalStorage();

		if (haveComments || (haveLocalComments && haveLocalComments.length > 0)) {
			this.commentsDb =
				this.data.index !== null && this.data.index !== undefined
					? this.data.comment[this.data.aspect][this.data.index]?.comments
					: this.data.comment[this.data.aspect]?.comments;

			if (this.commentsDb && this.commentsDb.length > 0) {
				this.hasCommentsDb = true;
			}

			const storedComments = this.getFromLocalStorage();

			if (storedComments && storedComments.length > 0) {
				this.commentsLocal = this.getCommentsById(this.data.id, storedComments)
					.filter(
						(comment: any) =>
							comment.keyIndicator === this.data.aspect &&
							comment.index === this.data.index,
					)
					.map((comment: any) => ({
						...comment,
						fromLocalStorage: true,
					}));
				if (this.commentsLocal.length > 0) {
					this.hasCommentsLocal = true;
				}
			}
		}
	}

	getCommentsById(id: string, aspectData: any[]) {
		const item = aspectData.find((element: any) => element.aspectIndId === id);
		return item ? item.comments : [];
	}

	// Función para guardar los datos en localStorage
	saveToLocalStorage(aspectData: any[]): void {
		localStorage.setItem('aspectComments', JSON.stringify(aspectData));
	}

	// Función para obtener los datos de localStorage
	getFromLocalStorage(): any[] {
		const storedData = localStorage.getItem('aspectComments');
		return storedData ? JSON.parse(storedData) : [];
	}

	getAvatar(user?: User) {
		return getUserAvatar(user!.name);
	}

	deleteComment(aspectIndId: string, commentIndex: number) {
		const aspectData = this.getFromLocalStorage();
		const aspect = aspectData.find((item) => item.aspectIndId === aspectIndId);

		const matchingComments = aspect.comments.filter(
			(comment: any) => comment.keyIndicator === this.data.aspect,
		);

		const nonMatchingComments = aspect.comments.filter(
			(comment: any) => comment.keyIndicator !== this.data.aspect,
		);

		matchingComments.splice(commentIndex, 1);

		this.commentsLocal = matchingComments;

		const combinedComments = [...matchingComments, ...nonMatchingComments];

		const aspectIndex = aspectData.indexOf(aspect);
		aspectData.splice(aspectIndex, 1);

		aspectData.push({
			aspectIndId: aspectIndId,
			comments: combinedComments,
		});

		this.saveToLocalStorage(aspectData);
	}

	// Función para agregar o actualizar el comentario
	addOrUpdateComment(data: any) {
		const aspectIndId = data.id; // Tomamos el aspectIndId de los datos proporcionados

		// Obtener los comentarios actuales desde localStorage
		const aspectData = this.getFromLocalStorage();

		// Buscar si ya existe un aspecto con este aspectIndId
		const aspect = aspectData.find((item) => item.aspectIndId === aspectIndId);

		const role = this.ls.getItem('role');
		const newComment = {
			keyIndicator: this.data.aspect,
			description: this.commentText,
			...(this.data.index !== null && this.data.index !== undefined
				? { index: this.data.index }
				: {}),
			date: new Date(),
			user: {
				name: this.actualUser,
			},
			fromLocalStorage: true, // Añadir la propiedad para identificar que es de localStorage
			...(role === 'secretary' ? { alert: true } : {}),
		};

		if (aspect) {
			// Si ya existe, agregar un nuevo comentario
			aspect.comments.push(newComment);
		} else {
			// Si no existe, crear un nuevo aspecto con el comentario
			aspectData.push({
				aspectIndId: aspectIndId,
				comments: [newComment],
			});
		}
		this.saveToLocalStorage(aspectData);
		this.commentsLocal.push(newComment);
		this.commentText = '';
		this.hasCommentsLocal = true;
	}

	onCommentInput() {
		this.empty = this.commentText.trim().length === 0 ? true : false;
	}
}
